<template lang="pug" functional>
.note
  slot
</template>

<script>
export default {};
</script>

<style scoped>
.note {
  max-height: 126px;
  font-family: 'Open Sans', sans-serif;
  color: #656565;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  overflow: hidden;
  max-height: 7em;
  margin-bottom: 20px;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// Note.vue?1c524811